import type { UnitNumberEntryQuoteFormInput } from 'app/home/create-quote/forms/unit-number-entry/unit-number-entry.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function unitNumberEntryQuoteFormSelector(store: QuoteDraftSelectorState): UnitNumberEntryQuoteFormInput {
  const unitNumber = store.unitNumber();
  return { unitNumber };
}

export function unitNumberEntryQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['unit-number-entry']();
}
